module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Penelope Lively\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Penelope Lively is the author of over twenty books of fiction and nonfiction, including the Booker Prize–winning novel "), _c('I', [_vm._v("Moon Tiger")]), _vm._v(" and the Whitbread Award–winning novel "), _c('I', [_vm._v("A Stitch in Time,")]), _vm._v(" as well as numerous children's books.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qAjhkA/tc-custom/9780802197351.jpg?1707880533056",
      "alt": "This image is the cover for the book Pack of Cards"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pack of Cards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An “abundantly rich collection” of short stories by the Man Booker Prize–winning author ("), _c('i', [_vm._v("The New York Times Book Review")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Pack of Cards")]), _vm._v(", Penelope Lively shares moments in the everyday world that are not always open to observation, as she delves into the minutiae of her characters’ lives."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Whether she writes about a widow on a visit to Russia, a small boy’s consignment to boarding school, or an agoraphobic housewife, Lively takes the reader behind a closed curtain, through the locked door, and into a world that seems at first mundane—then proves to be uniquely memorable."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Witty, profoundly civilized . . . This captivatingly intelligent collection confirms Lively’s place as one of Britain’s most imaginative and important contemporary writers.” —"), _c('i', [_vm._v("Library Journal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0